module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isActive) ? _c('div', {
    staticClass: "tab"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d89cfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tabs/Tab.vue
// module id = 1880
// module chunks = 0